import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type QuizsDTO =  {
    quiz:Quiz[];
    exams:Quiz[];
    essay:Quiz[];
}
export type Quiz = {
    id: string;
    title: string;
    lectureId: string;
    openLectureId?: string;
    chapterId:string
}
type getQuizsResponse = {
    statusCode?: number;
    error?: null | ApiError;
    data?: QuizsDTO;
  
}

export const GetAllQuizs = async (courseId:string): Promise<getQuizsResponse> => {
    try {
        const response = await axios.get(`/course/quizs/${courseId}`);
            return { data: response.data };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};